import script from "./AddEditHiddenBaseIngredients.vue?vue&type=script&setup=true&lang=js"
export * from "./AddEditHiddenBaseIngredients.vue?vue&type=script&setup=true&lang=js"

import "./AddEditHiddenBaseIngredients.vue?vue&type=style&index=0&id=416aa9f6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-416aa9f6"]])

export default __exports__